module.exports = __webpack_public_path__ + "media/icon/icon-slide-arrow-7d6e7561.svg";